import { useMutation } from "urql";

import { UpdateRMonAssignedDocument } from "../../../graphql/generated.ts";

export const useUpdateRMonAssigned = () =>
  useMutation(UpdateRMonAssignedDocument);
